module.exports = __webpack_public_path__ + "static/img/assistant.a5a6855.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/assistant.png
// module id = cQSL
// module chunks = 1